import { API } from '@portals/redux';
import {
  replaceNormalizedData,
  updateNormalizedData,
} from '@portals/redux/actions/data';
import { INTEGRATIONS_SCHEMA } from '@portals/redux/schemas';
import { upcaseFirst } from '@portals/utils';

export const testConnection = (type, params) => ({
  type: API,
  payload: {
    method: 'POST',
    url: `ui/partner/integrations/${type}/test`,
    data: params,
    toastr: 'Test connection',
  },
});

export const updateIntegration = (type, params, extraAction, onError) => ({
  type: API,
  payload: {
    method: 'PUT',
    url: `ui/partner/integrations/${type}`,
    data: params,
    normalize: INTEGRATIONS_SCHEMA,
    success: [updateNormalizedData('integrations'), extraAction],
    toastr: `${upcaseFirst(type)} integration updated`,
    error: onError,
    name: `integration_${type}`,
    withError: true,
  },
});

export const fetchIntegrations = () => ({
  type: API,
  payload: {
    url: 'ui/partner/integrations',
    success: replaceNormalizedData('integrations'),
    normalize: [INTEGRATIONS_SCHEMA],
    name: 'fetchIntegrations',
  },
});

export const reloadIntegration = (type, silent = false) => ({
  type: API,
  payload: {
    method: 'POST',
    url: `ui/partner/integrations/${type}/reload`,
    success: updateNormalizedData('integrations'),
    normalize: INTEGRATIONS_SCHEMA,
    name: `reloadIntegration${type}`,
    withError: true,
    toastr: silent ? null : `${type} integration update`,
  },
});

export const getIntegrationParam = (
  type,
  key,
  subKey = null,
  quiet = true
) => ({
  type: API,
  payload: {
    url: `ui/partner/integrations/${type}/param?key=${key}${
      subKey ? '&sub_key=' + subKey : ''
    }`,
    success: updateNormalizedData('integrations'),
    normalize: INTEGRATIONS_SCHEMA,
    name: `getIntegration_${type}_${key}_${subKey || ''}`,
    withError: true,
    toastr: quiet ? undefined : `Get ${type} info from server`,
  },
});

export const removeIntegration = (type) => ({
  type: API,
  payload: {
    method: 'DELETE',
    url: `ui/partner/integrations/${type}`,
    success: replaceNormalizedData('integrations'),
    normalize: INTEGRATIONS_SCHEMA,
    name: `removeIntegration${type}`,
    withError: true,
    toastr: `${type} removed`,
  },
});
